import {Box, HBox} from '@buncha/components/core/view';

import React from 'react';
import {Skeleton} from 'native-base';
import {StyleSheet} from 'react-native';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

const BarcodeListSkeleton = () => {
  const theme = useColorThemeType('main');
  return (
    <Box style={styles.parentBox}>
      <Box style={styles.topTextBox}>
        <Skeleton style={styles.text1} />
      </Box>

      <Skeleton
        style={[
          styles.text2,
          {
            backgroundColor: theme?.text?.blue?.[300],
          },
        ]}
      />
      <Box style={styles.bodyBox}>
        <HBox style={styles.rowBox}>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
        </HBox>
        <HBox style={styles.rowBox}>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
        </HBox>
        <HBox style={styles.rowBox}>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
        </HBox>
        <HBox style={styles.rowBox}>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
          <HBox style={styles.skeletonBox}>
            <Skeleton style={styles.barcodeText} />
            <Skeleton style={styles.checkIcon} />
          </HBox>
        </HBox>
      </Box>
    </Box>
  );
};

export default React.memo(BarcodeListSkeleton);

const styles = StyleSheet.create({
  parentBox: {
    gap: 30,
    marginTop: 15,
  },
  topTextBox: {
    gap: 10,
  },
  text1: {
    borderRadius: 20,
    height: 10,
  },
  text2: {
    borderRadius: 20,
    height: 20,
    width: '60%',
  },
  bodyBox: {
    gap: 20,
  },
  rowBox: {
    gap: 30,
    justifyContent: 'flex-start',
  },
  skeletonBox: {
    gap: 5,
    width: '45%',
  },
  barcodeText: {
    borderRadius: 20,
    height: 20,
    width: '90%',
  },
  checkIcon: {
    borderRadius: 100,
    height: 20,
    width: 20,
  },
});
